export const getValueSerializer = <T extends string>(): Serializer<T> => ({
  serialize: (v: T) => v,
  deserialize: (v: string) => v as T,
});

export type Serializer<T> = {
  serialize: (v: T) => string;
  deserialize: (v: string) => T;
};
